import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { IconTooltip } from "./IconTooltip";
export const DefinitionsTooltip = (props)=>/*#__PURE__*/ _jsx(IconTooltip, {
        "aria-label": props['aria-label'],
        color: "inherit",
        "data-testid": props['data-testid'],
        onClick: (event)=>event.stopPropagation(),
        title: /*#__PURE__*/ _jsxs(Stack, {
            spacing: 1,
            sx: {
                maxHeight: '60vh',
                overflowY: 'auto',
                p: 0.5
            },
            children: [
                !!props.title && /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle2",
                    children: props.title
                }),
                /*#__PURE__*/ _jsx(Stack, {
                    component: "dl",
                    spacing: 0.5,
                    sx: {
                        m: 0
                    },
                    children: props.definitions.map((item)=>/*#__PURE__*/ _jsxs(Stack, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    component: "dt",
                                    variant: "subtitle2",
                                    children: item.label
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    component: "dd",
                                    sx: {
                                        m: 0
                                    },
                                    variant: "body2",
                                    children: item.definition
                                })
                            ]
                        }, item.label))
                })
            ]
        }),
        trigger: /*#__PURE__*/ _jsx(InfoOutlined, {
            color: "inherit",
            fontSize: "small"
        })
    });
DefinitionsTooltip.displayName = 'DefinitionsTooltip';

//# sourceMappingURL=DefinitionsTooltip.js.map